import {
  CloseIcon,
  DeleteIcon,
  DeletePermanentlyIcon,
  ExportIcon,
  ResetIcon,
} from '@blocksuite/icons/rc';
import type { ReactNode } from 'react';

import {
  useWorkspacePaneBottomBarAvailable,
  WorkspacePaneBottomBar,
} from '../../../modules/streamlain/workspace-pane';
import {
  FloatingToolbar,
  type FloatingToolbarContentProps,
} from './floating-toolbar';
import * as styles from './list-floating-toolbar.css';

export const ListFloatingToolbar = ({
  content,
  onClose,
  open,
  onDelete,
  onRestore,
  onExport,
  contentProps,
}: {
  open: boolean;
  content: ReactNode;
  onClose: () => void;
  onDelete?: () => void;
  onRestore?: () => void;
  onExport?: () => void;
  contentProps?: FloatingToolbarContentProps;
}) => {
  // In a view surface the toolbar anchors in the surface's bar slot, above the AI island's dock
  // row; phone views have no slot and anchor it at the list's bottom.
  const inBarSlot = useWorkspacePaneBottomBarAvailable();
  const toolbar = (
    <FloatingToolbar
      className={inBarSlot ? undefined : styles.floatingToolbar}
      contentProps={contentProps}
      open={open}
    >
      <FloatingToolbar.Item>{content}</FloatingToolbar.Item>
      <FloatingToolbar.Button onClick={onClose} icon={<CloseIcon />} />
      {(!!onRestore || !!onDelete || !!onExport) && (
        <FloatingToolbar.Separator />
      )}
      {!!onExport && (
        <FloatingToolbar.Button
          onClick={onExport}
          icon={<ExportIcon />}
          data-testid="list-toolbar-export"
        />
      )}
      {!!onRestore && (
        <FloatingToolbar.Button
          onClick={onRestore}
          icon={<ResetIcon />}
          data-testid="list-toolbar-restore"
        />
      )}
      {!!onDelete && (
        <FloatingToolbar.Button
          onClick={onDelete}
          icon={onRestore ? <DeletePermanentlyIcon /> : <DeleteIcon />}
          type="danger"
          data-testid="list-toolbar-delete"
        />
      )}
    </FloatingToolbar>
  );
  return inBarSlot ? (
    <WorkspacePaneBottomBar>{toolbar}</WorkspacePaneBottomBar>
  ) : (
    toolbar
  );
};
